export default __webpack_public_path__ + "static/media/slider-1.2d16a594.png";